import { render } from "./send-command.vue?vue&type=template&id=71f5288d&scoped=true"
import script from "./send-command.vue?vue&type=script&lang=js"
export * from "./send-command.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-71f5288d"

export default script